import { useEffect } from "react";
import { titles } from "../../constants/titles";
import { useCurrentProductionArea } from "../../hooks";

export type AppTitleManagerProps = {
  serviceTitle: string;
};

const AppTitleManager: React.FC<AppTitleManagerProps> = ({ serviceTitle }) => {
  const { productionArea: currentArea } = useCurrentProductionArea();

  useEffect(() => {
    if (!currentArea) return;

    document.title = `${titles[currentArea]} ${serviceTitle}`;
  }, [currentArea]);

  return null;
};

export default AppTitleManager;
